// Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved.

/* Regex patterns grabbed from stackoverflow, can be tested here: https://regexr.com/37i6s and possibly other sources */
export const url_without_http_protocol = new RegExp(
	/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i
);
/* Regex grabbed from first answer: https://stackoverflow.com/questions/1701898/how-to-detect-whether-a-string-is-in-url-format-using-javascript */
export const valid_url = new RegExp(
	/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i
);

/* must include http:// or https// , www. is optional
	 must match any of domain in list
	 must end after domain or have a / to start path
	 ex: https://youtube.com && https://youtube.com/start valid, https://youtube.como not valid
	NOTE: all_words_in_list regex is a combo of logic from url_without_http_protocol taken from https://regexr.com/37i6s and custom logic
*/
export const all_words_in_list = (list: string[]) => {
	const regexStr = `http(s)?:\/\/(.*\\.)?(?:${list.join('|')})(/.*)?$`;
	return new RegExp(regexStr, 'i');
};
export const regexEmptyString = new RegExp(`^(?!\\s*$).+`);
